import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { usePageTitle } from '../hooks/usePageTitle';
import { getPageConfig, getAvatarTitle } from '../config/page-titles';

const PageTitleManager = ({ 
  customTitle, 
  customDescription, 
  avatarName, 
  avatarFilter = 'all' 
}) => {
  const location = useLocation();
  
  // Get base config for current page
  const baseConfig = getPageConfig(location.pathname);
  
  // Determine title and description
  let title = customTitle || baseConfig.title;
  let description = customDescription || baseConfig.description;
  
  // Handle avatar-specific titles
  if (location.pathname === '/avatars' && avatarName) {
    title = getAvatarTitle(avatarName, avatarFilter);
    description = `View ${avatarName}'s AI-generated avatar. Professional headshot with customizable styles.`;
  } else if (location.pathname === '/avatars' && avatarFilter !== 'all') {
    title = getAvatarTitle(null, avatarFilter);
    description = `Browse our collection of ${avatarFilter} AI-generated avatars. Professional and creative options available.`;
  }
  
  // Use the hook to set the title and meta tags
  usePageTitle({
    title,
    description,
    image: baseConfig.image,
    url: `${window.location.origin}${location.pathname}${location.hash ? location.hash : ''}`,
    setOpenGraph: true,
    setTwitterCard: true
  });
  
  return null; // This component doesn't render anything
};

export default PageTitleManager; 